import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useUserStore } from '@/stores/userStore'
     
export default /*@__PURE__*/_defineComponent({
  __name: 'UserGreeting',
  setup(__props) {

     const userStore = useUserStore()
     userStore.ensureLoaded()
 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('userComponent.greeting', [_unref(userStore).userName])), 1)
  ]))
}
}

})